export default function GlossaryPage() {
  const terms = [
    { term: '交易对', def: '两种数字资产的交换组合，如BTC/USDT表示用USDT买卖BTC' },
    { term: 'K线图', def: '以时间为轴的蜡烛图，显示开盘价、收盘价、最高价和最低价' },
    { term: '盘口', def: '当前买卖订单的集合，显示挂单价格和数量' },
    { term: '限价单', def: '按指定价格或更优价格成交的订单，适合精确控制买入卖出价格' },
    { term: '市价单', def: '按当前市场最优价格立即成交的订单，适合快速买入或卖出' },
    { term: '杠杆', def: '通过借入资金放大交易规模，收益和亏损同时放大' },
    { term: '保证金', def: '开仓所需的最低资金，用于抵押承担潜在亏损' },
    { term: '强平', def: '当保证金不足时，系统强制平仓以偿还借款' },
    { term: '资金费率', def: '合约市场中多空双方定期支付的费用，用于锚定现货价格' },
    { term: '滑点', def: '订单成交价格与预期价格之间的差异，通常在高波动时出现' },
  ]

  return (
    <div className="pt-24 pb-20" data-page-container>
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6"><span className="gradient-text">数字货币交易术语表</span></h1>
          <p className="text-muted text-lg leading-relaxed max-w-3xl">
            从基础到进阶，掌握常见交易术语的含义。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4" data-unique-module="crypto-term-definitions">
          {terms.map((item, i) => (
            <div key={i} className="cyber-card p-6">
              <h2 className="text-lg font-semibold text-cyber-text mb-2 font-mono">{item.term}</h2>
              <p className="text-muted text-sm leading-relaxed">{item.def}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
